
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as suDGyoHSGl9qkqC62LT97C2JamV4MlKyNoSyWIepxW1pMMeta } from "/app/pages/su.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as walletxPzMNZxL4B38IMnIBYlwlSRKRQKpVRAjoVHTKqLulFEMeta } from "/app/pages/wallet.vue?macro=true";
import { default as passkeysQGSSOGK_DyJ8TRoWge1_45daFwBKMx7mFfQB2u0srYjBgMeta } from "/app/pages/passkeys.vue?macro=true";
import { default as green_45c_45kycrt_0ejF4BLiVSIrefs3dRNl_N2xfDxYhvKTyAGK_45U9AMeta } from "/app/pages/green-c-kyc.vue?macro=true";
import { default as partnershipgIVh2DRLnDIBO1m0RSx_rbM64TksSFAVo_45aro_tJ5ZIMeta } from "/app/pages/partnership.vue?macro=true";
import { default as access_45deniedyHIOCACFsmpwjlfzNSutDWeVNnmI4q3U6OE5LDoq354Meta } from "/app/pages/access-denied.vue?macro=true";
import { default as kycQuf_45Whtpn9xNa8UjlBSNIarMFEZhp9JnH0WRNSmnny0Meta } from "/app/pages/card-blue/kyc.vue?macro=true";
import { default as green_45c_45indexm2Y0bu4gJB5aXZnNByQdgIghlk_45HTl_RipbQ42YER_45wMeta } from "/app/pages/green-c-index.vue?macro=true";
import { default as kycyi_eQ2eU4BsrcYRqeg8pE8O2w_3_vD3vrrMzc92YcikMeta } from "/app/pages/card-green/kyc.vue?macro=true";
import { default as indexmZSlhPWE4F9vrxwWwLteWCoFsX5DsJE5misukdPCu4UMeta } from "/app/pages/card-blue/index.vue?macro=true";
import { default as index6c2m4H_wuQp0WzQW9tFFEz1t_wb3bcflUGo_45639QhYcMeta } from "/app/pages/card-green/index.vue?macro=true";
import { default as issue_45processokf0tNAEMcwRjeQD0G9GrRvuQToUGK1Bne_45GpxLXa4oMeta } from "/app/pages/card-blue/issue-process.vue?macro=true";
import { default as issue_45processN_fiJSwcTdS2rC3U7hKm0k53doter7Ux_YktbIOoy04Meta } from "/app/pages/card-green/issue-process.vue?macro=true";
export default [
  {
    name: "su",
    path: "/su",
    component: () => import("/app/pages/su.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "wallet",
    path: "/wallet",
    component: () => import("/app/pages/wallet.vue")
  },
  {
    name: "passkeys",
    path: "/passkeys",
    component: () => import("/app/pages/passkeys.vue")
  },
  {
    name: "green-c-kyc",
    path: "/green-c-kyc",
    component: () => import("/app/pages/green-c-kyc.vue")
  },
  {
    name: "partnership",
    path: "/partnership",
    component: () => import("/app/pages/partnership.vue")
  },
  {
    name: "access-denied",
    path: "/access-denied",
    meta: access_45deniedyHIOCACFsmpwjlfzNSutDWeVNnmI4q3U6OE5LDoq354Meta || {},
    component: () => import("/app/pages/access-denied.vue")
  },
  {
    name: "card-blue-kyc",
    path: "/card-blue/kyc",
    component: () => import("/app/pages/card-blue/kyc.vue")
  },
  {
    name: "green-c-index",
    path: "/green-c-index",
    component: () => import("/app/pages/green-c-index.vue")
  },
  {
    name: "card-green-kyc",
    path: "/card-green/kyc",
    component: () => import("/app/pages/card-green/kyc.vue")
  },
  {
    name: "card-blue",
    path: "/card-blue",
    component: () => import("/app/pages/card-blue/index.vue")
  },
  {
    name: "card-green",
    path: "/card-green",
    component: () => import("/app/pages/card-green/index.vue")
  },
  {
    name: "card-blue-issue-process",
    path: "/card-blue/issue-process",
    component: () => import("/app/pages/card-blue/issue-process.vue")
  },
  {
    name: "card-green-issue-process",
    path: "/card-green/issue-process",
    component: () => import("/app/pages/card-green/issue-process.vue")
  }
]